module.exports = __webpack_public_path__ + "static/media/map.0ea07189.jpg";